import { gql, useMutation } from 'urql';
import { AdditionalGuestUpdate } from '@entities/clients';

const SET_SMINEX_CLUB_GUESTS_QUERY = gql`
  mutation SetSminexClubGuests($ticketId: Int!, $guests: [SminexClubGuestInput!]!) {
    setSminexClubGuests(ticketId: $ticketId, guests: $guests) {
      ticketId
    }
  }
`;

export const useSetSminexClubGuests = () => {
  const [{ data, error }, executeMutation] = useMutation(SET_SMINEX_CLUB_GUESTS_QUERY);

  const setSminexClubGuests = (ticketId: number, guests: AdditionalGuestUpdate[]) => {
    return executeMutation({ ticketId, guests });
  };

  return { data, error, setSminexClubGuests };
};
